import PropTypes from 'prop-types';

import Slot from '@zenbusiness/zui/Slot';
import { zuiPropTypes } from '@zenbusiness/zui/utils/propTypes';
import { useSlotProps } from '@zenbusiness/zui/utils/useSlotProps';
import { useStableSlots } from '@zenbusiness/zui/utils/useStableSlots';

import {
  InterstitialScreenContainer,
  InterstitialScreenContent,
  InterstitialScreenRoot,
  InterstitialScreenSubtitle,
  InterstitialScreenTitle
} from './InterstitialScreen.style';

function InterstitialScreen({
  slots: inSlots,
  slotProps: inSlotProps,
  subtitle,
  title,
  ...delegated
}) {
  const { slots, slotProps } = useStableSlots(inSlots, inSlotProps);

  const Root = slots.root ?? InterstitialScreenRoot;
  const rootProps = useSlotProps(Root, slotProps.root, {
    propsDelegated: delegated
  });

  const Container = slots.container ?? InterstitialScreenContainer;
  const containerProps = useSlotProps(Container, slotProps.container);

  const Start = slots.start;
  const startProps = useSlotProps(Start, slotProps.start);

  const Content = slots.content ?? InterstitialScreenContent;
  const contentProps = useSlotProps(Content, slotProps.content);

  const Title = slots.title ?? InterstitialScreenTitle;
  const titleProps = useSlotProps(Title, slotProps.title);

  const Subtitle = slots.subtitle ?? InterstitialScreenSubtitle;
  const subtitleProps = useSlotProps(Subtitle, slotProps.subtitle);

  const End = slots.end;
  const endProps = useSlotProps(End, slotProps.end);

  return (
    <Slot component={Root} props={rootProps}>
      <Slot component={Container} props={containerProps}>
        <Slot component={Start} props={startProps} />

        <Slot component={Content} props={contentProps}>
          <Slot component={Title} props={titleProps}>
            {title}
          </Slot>
          <Slot component={Subtitle} props={subtitleProps}>
            {subtitle}
          </Slot>
        </Slot>

        <Slot component={End} props={endProps} />
      </Slot>
    </Slot>
  );
}

InterstitialScreen.propTypes = {
  slots: PropTypes.shape({
    container: zuiPropTypes.slotType,
    content: zuiPropTypes.slotType,
    end: zuiPropTypes.slotType,
    root: zuiPropTypes.slotType,
    start: zuiPropTypes.slotType,
    subtitle: zuiPropTypes.slotType,
    title: zuiPropTypes.slotType
  }),
  slotProps: PropTypes.shape({
    container: zuiPropTypes.slotPropType,
    content: zuiPropTypes.slotPropType,
    end: zuiPropTypes.slotPropType,
    root: zuiPropTypes.slotPropType,
    start: zuiPropTypes.slotPropType,
    subtitle: zuiPropTypes.slotPropType,
    title: zuiPropTypes.slotPropType
  }),
  subtitle: PropTypes.string,
  title: PropTypes.string
};

export default InterstitialScreen;
